const vlink = "./fuhua-vt-202220628/index.htm?skip-loading&media-index=";
module.exports = {
	baseRouter: '',
	shcoolCLassList: [
		{
			img: 'h_0.jpg',
			name: 'Our Campus',
			dsc: '',
			list: [
				{
					avtar: '0.png',
					img: 'OurSchoolCampus.jpg',
					link: vlink + '1',
					name: 'Our School Campus',
					dsc: '',
				},
				// {
				// 	avtar: '1.png',
				// 	img: 'GeneralOffice.jpg',
				// 	link: vlink + '2',
				// 	name: 'General Office',
				// 	dsc: '',
				// },
				// {
				// 	avtar: '2.png',
				// 	img: 'Courtyard.jpg',
				// 	link: vlink + '4',
				// 	name: 'Courtyard',
				// 	dsc: '',
				// },
				// {
				// 	avtar: '3.png',
				// 	img: 'Canteen.jpg',
				// 	link: vlink + '5',
				// 	name: 'Canteen',
				// 	dsc: '',
				// },
				// {
				// 	avtar: '3.png',
				// 	img: 'DentalClinic.jpg',
				// 	link: vlink + '12',
				// 	name: 'Dental Clinic',
				// 	dsc: '',
				// },
				// {
				// 	avtar: '2.png',
				// 	img: 'SchoolHall.jpg',
				// 	link: vlink + '14',
				// 	name: 'School Hall',
				// 	dsc: '',
				// },
				// {
				// 	avtar: '1.png',
				// 	img: 'Classroom.jpg',
				// 	link: vlink + '17',
				// 	name: 'Classroom',
				// 	dsc: '',
				// },
			]
		},
		{
			img: 'h_1.jpg',
			name: 'Collaboration & Research',
			dsc: '',
			list: [
				{
					avtar: '0.png',
					img: 'LearningHub.jpg',
					link: vlink + '14', //16
					name: 'Learning Hub',
					dsc: '',
				},
				{
					avtar: '1.png',
					img: 'ScienceLab.jpg',
					link: vlink + '19', // 21
					name: 'Science Lab',
					dsc: '',
				},
			]
		},
		{
			img: 'h_2.jpg',
			name: 'Media & Languages',
			dsc: '',
			list: [
				{
					avtar: '0.png',
					img: 'Library.jpg',
					link: vlink + '11',
					name: 'Library',
					dsc: '',
				},
				{
					avtar: '1.png',
					img: 'MotherTongueHub.jpg',
					link: vlink + '18',
					name: 'Mother Tongue Hub',
					dsc: '',
				},
				{
					avtar: '2.png',
					img: 'LittleDreamBox.jpg',
					link: vlink + '6',
					name: 'Little Dream Box',
					dsc: '',
				},
				// {
				// 	avtar: '3.png',
				// 	img: 'LearningSupportRoomMathematics.jpg',
				// 	link: vlink + '6',
				// 	name: 'Learning Support Room (Mathematics)',
				// 	dsc: '',
				// },
				// {
				// 	avtar: '0.png',
				// 	img: 'LearningSupportRoomEnglish.jpg',
				// 	link: vlink + '7',
				// 	name: 'Learning Support Room (English)',
				// 	dsc: '',
				// },
			]
		},
		{
			img: 'h_3.jpg',
			name: 'Creative Design & Making',
			dsc: '',
			list: [
				{
					avtar: '0.png',
					img: 'MakersStudio.jpg',
					link: vlink + '9',
					name: 'Makers Studio',
					dsc: '',
				},
				{
					avtar: '1.png',
					img: 'OutdoorExperientialLearningGarden.jpg',
					link: vlink + '8',
					name: 'Outdoor Experiential Learning Garden',
					dsc: '',
				},
				{
					avtar: '2.png',
					img: 'MusicRoom.jpg',
					link: vlink + '13',
					name: 'Music Room',
					dsc: '',
				},
				{
					avtar: '3.png',
					img: 'MultimediaProductionStudio.jpg',
					link: vlink + '16',
					name: 'Multimedia Production Studio',
					dsc: '',
				},

				{
					avtar: '2.png',
					img: 'ArtRoom.jpg',
					link: vlink + '7',
					name: 'Art Room',
					dsc: '',
				},
				{
					avtar: '0.png',
					img: 'Bandroom.jpg',
					link: vlink + '20',
					name: 'Band Room',
					dsc: '',
				},
			]
		},
		{
			img: 'h_4.jpg',
			name: 'Communities @ Play',
			dsc: '',
			list: [
				{
					avtar: '0.png',
					img: 'IndoorSportsHall.jpg',
					link: vlink + '17',
					name: 'Indoor Sports Hall',
					dsc: '',
				},
				{
					avtar: '1.png',
					img: 'SchoolFieldBasketballCourt.jpg',
					link: vlink + '3',
					name: 'School Field and Basketball Court',
					dsc: '',
				},
			]
		},

	],
};
